import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

const customersRoutesMeta = {
  routeName: window.$_t("Customers"),
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
};

const rfmRoutesMeta = {
  routeName: window.$_t("RFM Analysis"),
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
};

export const customersRoutes = [
  {
    path: "/app/customers",
    name: "PageCustomers",
    component: () => import("../pages/PageCustomers.vue"),
    meta: customersRoutesMeta,
  },
  {
    path: "/app/rfm-analysis",
    name: "PageRFMAnalysis",
    component: () => import("../../vue-app/pages/PageRFMAnalysis.vue"),
    redirect: "/app/rfm-analysis/rfm-overview",
    children: [
      {
        path: "/app/rfm-analysis/rfm-overview",
        component: () => import("vue-app/components/Customers/RFMAnalysisOverview.vue"),
        meta: rfmRoutesMeta,
      },
      {
        path: "/app/rfm-analysis/rfm-settings",
        component: () => import("vue-app/components/Customers/RFMAnalysisSettings.vue"),
        meta: rfmRoutesMeta,
      },
      {
        path: "/app/rfm-analysis/rfm-breakdown",
        component: () => import("vue-app/components/Customers/RFMAnalysisBreakdown.vue"),
        meta: rfmRoutesMeta,
      },
    ],
  },
];

export const crmRoutes = [
  {
    path: "/crm",
    redirect: "/app/crm",
  },
  {
    path: "/customer/single",
    redirect: "/app/customer/single",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
    },
  },
  {
    path: "/customer/deleted",
    redirect: "/app/customer/deleted",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
    },
  },
  {
    path: "/customer/search",
    redirect: "/app/customer/search",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
    },
  },
  {
    path: "/app/customer/deleted",
    component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
    meta: {
      routeName: window.$_t("CUSTOMER"),
      legacyHref: "/customer/deleted",
      legacyLayout: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
    },
  },
  {
    path: "/app/customer/search",
    component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
    meta: {
      routeName: window.$_t("CUSTOMER"),
      legacyHref: "/customer/search",
      legacyLayout: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
    },
  },
  {
    path: "/app/crm",
    component: () => import("vue-app/pages/PageDashboardCrm.vue"),
    name: "app-crm",
    meta: {
      routeName: window.$_t("CRM"),
      legacyHref: "/crm",
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/tags",
    component: () => import("vue-app/pages/PageTags/PageTags.vue"),
    meta: {
      routeName: window.$_t("TAGS"),
      legacyLayout: false,
      noPadding: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_CRM],
      skipGlobalLoader: true,
    },
  },
];
